module.exports = __webpack_public_path__ + "public/img/leao.2faafce0.svg";